// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2507":"c6626e9e","3328":"c6626e9e"}[chunkId] + ".chunk.css";
};